<template>


    <b-modal class="modal fade" ref="dangerous-goods-modal" centered size="md" scrollable style="padding: 10px">

        <template v-slot:modal-header>
            <slot name="header">
                <h6 class="modal-title">{{ editMode == "add" ? "Add" : "Edit" }} Dangerous Goods Item</h6>





            </slot>
            <slot name="close-button">
                <button type="button" class="close" @click="closeDangerousGoodsModal" data-dismiss="modal"
                    aria-label="Close">
                    <span>×</span>
                </button>
            </slot>
        </template>

        <div style="height: 300px; width: 100%; margin-bottom: 20px;" v-if="selectedItem != null">





            <b-row>




                <b-col class="less-padding">
                    <!-- <base-input label="Date Of Loss" v-model="selectedItem.claim.dateOfLoss"
                        inputGroupClasses="uBind-input" /> -->

                    <base-input name="Dangerous Goods Class"
                        label="Dangerous Goods Class"
                        inputGroupClasses="uBind-input">
                        <el-select v-model="selectedItem.dangerousGoods.dangerousGoodsClass">
                            <el-option v-for="option in dangerousGoodsClasses" :key="option.label" :label="option.label"
                                :value="option.value">
                            </el-option>
                        </el-select>
                    </base-input>

                </b-col>

            </b-row>

            <b-row>




                <b-col class="less-padding">
                    <base-input type="number" label="Quantity" v-model="selectedItem.dangerousGoods.dangerousGoodsQuantity"
                        inputGroupClasses="uBind-input" />

                </b-col>

            </b-row>

            <b-row>


                <b-col class="less-padding">
                    <base-input label="Description" v-model="selectedItem.dangerousGoods.dangerousGoodsDescription"
                        inputGroupClasses="uBind-input" />

                </b-col>
            </b-row>

            <!-- <b-row>
                <b-col class="less-padding">
                    <base-input label="Make" v-if="selectedItem.vehicle.vehicleType != 'SE1'"
                        v-model="selectedItem.vehicle.motorwebGlasses.make" inputGroupClasses="uBind-input" />

                    <base-input label="Make" v-if="selectedItem.vehicle.vehicleType == 'SE1'" name="Make"
                        inputGroupClasses="uBind-input">
                        <el-select @change="selectedItem.vehicle.motorwebGlasses.family = ''"
                            v-model="selectedItem.vehicle.motorwebGlasses.make">
                            <el-option v-for="option in carModels" :key="option.Make" :label="option.Make"
                                :value="option.Make">
                            </el-option>
                        </el-select></base-input>

                </b-col>

                <b-col class="less-padding">


                    <base-input label="Family" v-if="selectedItem.vehicle.vehicleType == 'SE1'" name="Family"
                        inputGroupClasses="uBind-input">
                        <el-select v-model="selectedItem.vehicle.motorwebGlasses.family">
                            <el-option
                                v-for="option in (carModels.find(f => f.Make == selectedItem.vehicle.motorwebGlasses.make) ? carModels.find(f => f.Make == selectedItem.vehicle.motorwebGlasses.make).Models : [])"
                                :key="option" :label="option" :value="option">
                            </el-option>
                        </el-select></base-input>



                    <base-input label="Family" v-if="selectedItem.vehicle.vehicleType != 'SE1'"
                        v-model="selectedItem.vehicle.motorwebGlasses.family" inputGroupClasses="uBind-input" />


                </b-col>

                <b-col class="less-padding">
                    <base-input label="Vehicle Year" v-model="selectedItem.vehicle.vehicleYear"
                        inputGroupClasses="uBind-input" />

                </b-col>



            </b-row> -->

            <!-- <b-row>
                <b-col class="less-padding">
                    <base-input label="Sum Insured" v-model="selectedItem.vehicle.sumInsured"
                        inputGroupClasses="uBind-input" />

                </b-col>
            </b-row> -->





        </div>

        <template v-slot:modal-footer>
            <b-button icon @click="closeDangerousGoodsModal()">Cancel</b-button>
            <b-button icon @click="saveDangerousGoodsItem()">Save</b-button>
        </template>

    </b-modal>

</template>

<script>
//import MotorContinueQuote from "../../components/MotorContinueQuote.vue";
import BaseInput from "../../../components/Inputs/BaseInput.vue";
import { Select, Option, DatePicker } from "element-ui";
import VueMultiselectComponent from 'vue-multiselect-component'
import { entsiaDropDowns } from "../../../assets/data/entsiaLOVs";

export default {
    name: "DangerGoodsModal",
    //policy_id: "",
    //selectedCustomerId: 0,
    // props: {
    //     vehicleEditMode: {
    //         type: String
    //     },
    //     //selectedItem: null 
    //     _selectedItem: {
    //         type: Object
    //     },
    // },
    data() {
        return {
            //value: [],
            editMode: 'add',
            selectedItem: null,
            selectedIdx: null,
            freightTaskOptions: entsiaDropDowns.freightTaskOptions,
            vehicleTypeOptions: entsiaDropDowns.vehicleTypeOptions,
            dangerousGoodsClasses: entsiaDropDowns.dangerousGoodsClasses,
            pickerOptions: {
                // disabledDate(time) {
                //     return !moment(time.getTime()).isBetween('2022-01-01', Date.now());
                // },
            },
        }
    },
    methods: {
        saveDangerousGoodsItem() {
            this.$emit('saveDangerousGoodsItem', this.selectedItem);
            this.$refs['dangerous-goods-modal'].hide();
        },
        closeDangerousGoodsModal() {
            this.$refs['dangerous-goods-modal'].hide();
        },
        openDangerousGoodsModal(_mode, _item, _idx) {

            //console.log(_mode,_item,_idx);

            //console.log(_item.vehicle.vehicleType);

            this.editMode = _mode;
            this.selectedItem = _item;
            this.selectedIdx = _idx;
            this.$refs['dangerous-goods-modal'].show();
        },
    },
    components: {
        BaseInput,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        //Spinner,
        //FileUpload,
        VueMultiselectComponent
    },
    async mounted() {
        //console.log("c13");
        //this.$refs['vehicle-modal'].show();

        //console.log(this._selectedItem);
        //this.selectedItem = this._selectedItem;
    }
};
</script>
